"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = exports.InvalidUserError = void 0;
const one_brandkey_1 = require("@prismamedia/one-brandkey");
const Role_js_1 = require("./types/Role.js");
const RoleUnit_js_1 = require("./types/RoleUnit.js");
const enum_js_1 = require("./utils/enum.js");
__exportStar(require("./types/Role.js"), exports);
__exportStar(require("./types/RoleUnit.js"), exports);
class InvalidUserError extends Error {
}
exports.InvalidUserError = InvalidUserError;
class User {
    id;
    name;
    email;
    avatarUrl;
    createdAt;
    googleId;
    roles;
    roleMap;
    constructor(user) {
        if (!user.id || !user.email || !Array.isArray(user.roles)) {
            throw new InvalidUserError();
        }
        this.id = user.id;
        this.name = user.name;
        this.email = user.email;
        this.createdAt = user.createdAt || '';
        this.googleId = user.googleId || null;
        this.avatarUrl = user.avatarUrl || null;
        this.roles = user.roles.filter((roleWithUnit) => {
            const [role, brandKey] = roleWithUnit.split('-');
            return (0, Role_js_1.isRole)(role) && (brandKey === 'ALL' || (0, one_brandkey_1.isUnit)(brandKey));
        });
        this.roleMap = this.roles.reduce((roleMap, role) => {
            const explodedRole = role.split('-');
            if (explodedRole.length === 2) {
                const [maybeRole, maybeUnit] = explodedRole;
                if ((0, Role_js_1.isRole)(maybeRole) && (0, RoleUnit_js_1.isRoleUnit)(maybeUnit)) {
                    if (!(maybeRole in roleMap)) {
                        roleMap[maybeRole] = [];
                    }
                    if (!roleMap[maybeRole].includes(maybeUnit)) {
                        roleMap[maybeRole]?.push(maybeUnit);
                    }
                }
            }
            return roleMap;
        }, {});
    }
    hasRoleOnUnit(role, unit = 'ALL') {
        return (this.hasRole(role) &&
            (this.roleMap[role].includes(unit) ||
                (unit !== 'ALL' && this.roleMap[role].includes('ALL'))));
    }
    hasRole(role) {
        return (0, Role_js_1.isRole)(role) && !!this.roleMap[role];
    }
    hasRolesOnUnit(roles, unit) {
        return roles.some((role) => this.hasRoleOnUnit(role, unit));
    }
    hasRoleOnUnits(role, units) {
        return units.some((unit) => this.hasRoleOnUnit(role, unit));
    }
    hasRolesOnUnits(roles, units) {
        return roles.some((role) => units.some((unit) => this.hasRoleOnUnit(role, unit)));
    }
    isSuperAdmin() {
        return this.hasRoleOnUnit(Role_js_1.Role.Superadmin);
    }
    assertIsSuperAdmin() {
        if (!this.isSuperAdmin()) {
            throw new Error(`User should be a superadmin`);
        }
    }
    isAdmin(unit) {
        return this.hasRoleOnUnit(Role_js_1.Role.Admin, unit);
    }
    assertIsAdmin(unit) {
        if (!this.isAdmin(unit)) {
            throw new Error(`User should be an admin`);
        }
    }
    getUnitSet(excludedRoles = []) {
        const units = Object.entries(this.roleMap).reduce((currentUnits, [role, units]) => {
            if (!excludedRoles.includes(role) && units) {
                currentUnits.push(...units.filter((unit) => unit !== 'ALL'));
            }
            return currentUnits;
        }, []);
        return new Set(units);
    }
    /**
     * "ALL" is a special unit
     */
    getUnits(excludedRoles = []) {
        //We filter "ALL" from RoleUnit, so we can cast the return to Unit[]
        return Array.from(this.getUnitSet(excludedRoles)).filter((unit) => !['ALL'].includes(unit));
    }
    getUnitsForRoles(roles) {
        let units = new Set();
        // using for so we can break early in case of a role with 'ALL'
        for (let i = 0; i < roles.length; i++) {
            if (this.hasRole(roles[i])) {
                const rolesUnits = this.roleMap[roles[i]];
                if (rolesUnits.includes('ALL')) {
                    return (0, enum_js_1.getEnumValues)(one_brandkey_1.Unit);
                }
                for (let unit of rolesUnits) {
                    units.add(unit);
                }
            }
        }
        return Array.from(units);
    }
    getUserBrandKeysForRoles(roles) {
        return (0, one_brandkey_1.getBrandKeysForUnits)(this.getUnitsForRoles(roles));
    }
    // Todo:move this to topic api
    isAllowedOnRawArticle(rawArticle, roles, allowOwner) {
        if (this.isSuperAdmin() || this.isAdmin() || this.hasRolesOnUnit(roles)) {
            return true;
        }
        const unit = (rawArticle.assignment && rawArticle.assignment.subject.unit.title) || null;
        const editorId = (rawArticle.lastVersion && rawArticle.lastVersion.editorId) || null;
        return ((unit && (this.isAdmin(unit) || this.hasRolesOnUnit(roles, unit))) ||
            (allowOwner && editorId && this.id === editorId));
    }
}
exports.User = User;
//# sourceMappingURL=index.js.map